import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { VStack, HStack, Button } from '@chakra-ui/react';

import ListingDetails from './ListingDetails';
import ListingInventory from './ListingInventory';
import SupplierInventory from './SupplierInventory';
import ItemSupplierDetails from './ItemSupplierDetails';
import ImageManagement from './ImageManagement';
import ItemSpecifications from './ItemSpecifications';
import ListingDescription from './ListingDescription';
import { deleteListingApi } from '../../../../features/listings/listings.api';

const GeneralTab = ({
  images,
  setImages,
  errorImages,
  setErrorImages,
  getMaxImages,
  listing,
  onListingUpdate,
  onUpdate,
  onDelete,
  isUpdating = false,
  hasChanges = false,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDeleteListing = () => {
    dispatch(deleteListingApi(listing._id));
    navigate('/admin/listings');
  };

  return (
    <VStack spacing={6} align="stretch">
      {/* Top Row: Listing Details and Inventory Cards */}
      <HStack spacing={4} align="stretch">
        <ListingDetails listing={listing} onUpdate={onListingUpdate} />

        {/* Right Column: Listing Inventory and Supplier Inventory */}
        <VStack spacing={6} flex="1" align="stretch">
          <ListingInventory listing={listing} onUpdate={onListingUpdate} />
          <SupplierInventory listing={listing} />
        </VStack>
      </HStack>

      {/* Middle Row: Image Management and Item Supplier Details */}
      <HStack spacing={4} align="stretch">
        <ImageManagement
          images={images}
          setImages={setImages}
          errorImages={errorImages}
          setErrorImages={setErrorImages}
          getMaxImages={getMaxImages}
          listing={listing}
        />

        <ItemSupplierDetails listing={listing} onUpdate={onListingUpdate} />
      </HStack>

      {/* Item Specifications Section */}
      <ItemSpecifications listing={listing} onUpdate={onListingUpdate} />

      {/* Description Section */}
      <ListingDescription listing={listing} onUpdate={onListingUpdate} />

      {/* Action Buttons */}
      <HStack justify="flex-end" spacing={4} pt={4}>
        <Button
          colorScheme="red"
          variant="outline"
          onClick={handleDeleteListing}
          size="md"
          w="20%"
        >
          Delete
        </Button>
        <Button
          colorScheme="blue"
          onClick={onUpdate}
          size="md"
          w="20%"
          isLoading={isUpdating}
          loadingText="Updating..."
          isDisabled={!hasChanges || isUpdating}
        >
          Update
        </Button>
      </HStack>
    </VStack>
  );
};

export default GeneralTab;
